import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, Activity } from 'lucide-react';

const Hero = ({ onStart }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      exit={{ opacity: 0, y: -20 }}
      className="text-center mt-20 px-4"
    >
      <div className="flex justify-center mb-6">
        <div className="p-4 bg-blue-600/20 rounded-full">
          <Activity size={48} className="text-blue-500" />
        </div>
      </div>
      
      <h1 className="text-5xl md:text-7xl font-extrabold mb-6 tracking-tight text-white">
        Your AI <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">Fitness Coach</span>
      </h1>
      
      <p className="text-lg md:text-xl text-slate-400 mb-8 max-w-2xl mx-auto">
        Stop guessing. Get a fully personalized workout and diet plan generated by Artificial Intelligence in seconds.
      </p>
      
      <button 
        onClick={onStart} 
        className="group relative inline-flex items-center justify-center px-8 py-4 font-bold text-white transition-all duration-200 bg-blue-600 rounded-full hover:bg-blue-500 hover:scale-105 focus:outline-none ring-offset-2 focus:ring-2 ring-blue-400"
      >
        Start Transformation
        <ChevronRight className="ml-2 group-hover:translate-x-1 transition-transform" />
      </button>
    </motion.div>
  );
};

export default Hero;